var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloseMenu = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 6.5,
    fill: "#fff",
    stroke: "#F45369"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.913 14.036 4.76-4.76a.467.467 0 0 0 0-.66L19.42 7.362a.467.467 0 0 0-.66 0L14 12.123l-4.76-4.76a.468.468 0 0 0-.66 0L7.326 8.615a.467.467 0 0 0 0 .661l4.76 4.76-4.76 4.76a.467.467 0 0 0 0 .66l1.252 1.252a.467.467 0 0 0 .661 0l4.76-4.76 4.76 4.76a.467.467 0 0 0 .66 0l1.252-1.252a.467.467 0 0 0 0-.66l-4.76-4.76Z",
    fill: "#F45369"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloseMenu);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/close-menu.3d5f268da6268dccbcef504590b9f345.svg";